// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview.select-item .thumbnail[data-v-2b65e40a]{height:132px}.asset-preview.select-item .thumbnail img[data-v-2b65e40a]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-2b65e40a]{opacity:1}", ""]);
// Exports
module.exports = exports;
